import { useState } from 'react';

function americanToDecimal(american) {
	const a = parseFloat(american);
	if (isNaN(a) || a === 0) return NaN;
	if (a > -100 && a < 100) return NaN;
	if (a > 0) return a / 100 + 1;
	return 100 / Math.abs(a) + 1;
}

export const EvCalculator = () => {
	const [odds, setOdds] = useState('');
	const [trueProbInput, setTrueProbInput] = useState('');
	const [stake, setStake] = useState('');

	const decimal = americanToDecimal(odds);
	const trueProb = parseFloat(trueProbInput) / 100;
	const stakeNum = parseFloat(stake);

	const hasResults = !isNaN(decimal) && decimal > 1 && !isNaN(trueProb) && trueProb > 0 && trueProb < 1 && !isNaN(stakeNum) && stakeNum > 0;

	let results = null;
	if (hasResults) {
		const profitIfWin = stakeNum * (decimal - 1);
		const ev = (trueProb * profitIfWin) - ((1 - trueProb) * stakeNum);
		const evPct = ((trueProb * decimal) - 1) * 100;
		const breakevenProb = (1 / decimal) * 100;
		results = { ev, evPct, breakevenProb, profitIfWin };
	}

	const handleReset = () => {
		setOdds('');
		setTrueProbInput('');
		setStake('');
	};

	return (
		<div>
			<div className="calc-section">
				<h3 className="calc-section-title">Bet Details</h3>
				<div className="calc-grid calc-grid-3">
					<div className="calc-input-group">
						<label className="calc-label">Your Odds (American)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="+150"
							value={odds}
							onChange={(e) => setOdds(e.target.value)}
						/>
					</div>
					<div className="calc-input-group">
						<label className="calc-label">True Win Probability (%)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="45"
							value={trueProbInput}
							onChange={(e) => setTrueProbInput(e.target.value)}
						/>
					</div>
					<div className="calc-input-group">
						<label className="calc-label">Stake ($)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="100"
							value={stake}
							onChange={(e) => setStake(e.target.value)}
						/>
					</div>
				</div>
			</div>

			{results && (
				<div className="calc-results">
					<h4 className="calc-results-title">Expected Value Results</h4>
					<div className="calc-result-row">
						<span className="calc-result-label">Expected Value</span>
						<span className={`calc-result-value ${results.ev >= 0 ? 'positive' : 'negative'}`}>
							{results.ev >= 0 ? '+' : ''}${results.ev.toFixed(2)}
						</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">EV Percentage</span>
						<span className={`calc-result-value ${results.evPct >= 0 ? 'positive' : 'negative'}`}>
							{results.evPct >= 0 ? '+' : ''}{results.evPct.toFixed(2)}%
						</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Profit if Win</span>
						<span className="calc-result-value positive">${results.profitIfWin.toFixed(2)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Breakeven Probability</span>
						<span className="calc-result-value">{results.breakevenProb.toFixed(2)}%</span>
					</div>
				</div>
			)}

			<button className="calc-reset-btn" onClick={handleReset}>Reset</button>
		</div>
	);
};
